import { render, staticRenderFns } from "./ImageCredits.vue?vue&type=template&id=c8ad5c00&scoped=true&"
import script from "./ImageCredits.vue?vue&type=script&lang=js&"
export * from "./ImageCredits.vue?vue&type=script&lang=js&"
import style0 from "./ImageCredits.vue?vue&type=style&index=0&id=c8ad5c00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ad5c00",
  null
  
)

export default component.exports